import React from 'react';

const AnsInput = ({state, setState}) => {

    return <textarea placeholder="Resposta" value={state} onChange={(e) => {setState(e.target.value)}}/>

}

export default function AnswerInput({answerValue}) {

    const [ state, setState ] = React.useState( answerValue );

    return (
        <AnsInput state={state} setState={setState}/>
    )

}